// Main scripts
import "../styles/style.scss";
import "fslightbox";
import "./components/theme-switcher";
import "./components/header";
import "./components/webcams";
import "./components/three/init-gradients";
import "./components/ymaps/init-ymaps-modal";

import "./blocks/slope-slider/init-slope-slider";
import "./utils/app-height";

import { Fancybox } from "@fancyapps/ui";

Fancybox.bind();
